// extracted by mini-css-extract-plugin
export default {"gray500":"#adb5bd","ConsentManagerTable":"ConsentManager_ConsentManagerTable__gNq9q"};